import {
  Archive,
  Bot,
  Cloud,
  Globe,
  Server,
  ServerCog,
  Signal,
  Smartphone,
  Video,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { fileArchiveDirectHref } from "@/lib/file-archive";

export const TOOLS_SECTION_TITLE = "Tools";
export const TOOLS_OVERVIEW_HREF = "/tools";

export interface Tool {
  /** Stored in the user's favorites: keep it stable when renaming a tool. */
  id: string;
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
  /** Absolute URL to another app, opened in a new tab */
  external?: boolean;
  /**
   * When it returns a URL, the sidebar entry opens it in a new tab instead of
   * `href`. The overview page always goes to `href`.
   */
  externalHref?: () => string | undefined;
}

export const tools: Tool[] = [
  {
    id: "cloud-media",
    title: "Cloud Media",
    description: "AWS MediaConnect flows and MediaLive channels.",
    icon: Cloud,
    href: "/cloud-media",
  },
  {
    id: "cloud-computers",
    title: "Cloud Computers",
    description: "Start, stop and connect to cloud machines.",
    icon: Server,
    href: "/cloud-computers",
  },
  {
    id: "camera-control",
    title: "Camera Control",
    description: "Remote camera control, in its own app.",
    icon: Video,
    href: "https://cameras.livemotion.ch",
    external: true,
  },
  {
    id: "file-archive",
    title: "File Archive",
    description: "The archive drives of the studio PC: browse, play and share.",
    icon: Archive,
    href: "/file-archive",
    externalHref: fileArchiveDirectHref,
  },
  {
    id: "https-forwards",
    title: "HTTPS Forwards",
    description: "Public HTTPS names that forward to internal web resources.",
    icon: Globe,
    href: "/https-forwards",
  },
  {
    id: "managed-servers",
    title: "Managed Servers",
    description: "Launch and manage servers such as LM IO Server.",
    icon: ServerCog,
    href: "/managed-servers",
  },
  {
    id: "network-coverage",
    title: "Network Coverage",
    description: "Mobile network coverage measurements.",
    icon: Signal,
    href: "/network-coverage",
  },
  {
    id: "sims",
    title: "SIM Cards",
    description: "Search, activate and deactivate SIM cards.",
    icon: Smartphone,
    href: "/sims",
  },
  {
    id: "ai-agent",
    title: "AI Agent",
    description: "Set up the AI agent and pair its devices.",
    icon: Bot,
    href: "/ai-agent",
  },
];
